<template>
  <div
    class="animated_text_div"
    :class="{ unanimate: !startAnim }"
    ref="animated_box"
    :style="Width + speed"
  >
    <p class="p1" :class="{ animated_p: startAnim }" ref="p1">
      {{ spaceText + text }}
    </p>
    <p v-if="startAnim" class="p2" ref="p2">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "animatedText",
  props: { text: String },
  data() {
    return {
      startAnim: false,
      Width: "--w:0px;",
      spaceText: "",
      speed: "--speed: long_text_anim 5s linear infinite;",
    };
  },
  mounted() {
    if (this.$refs.p1.offsetWidth > this.$refs.animated_box.offsetWidth) {
      this.Width = "--w:-" + this.$refs.p1.offsetWidth + "px;";
      this.speed = `--speed: long_text_anim ${
        this.$refs.p1.offsetWidth / 50
      }s linear infinite;`;
      this.startAnim = true;
      window.addEventListener("resize", () => {
        this.Width = "--w:-" + this.$refs.p2.offsetWidth + "px;";
      });
    }
  },
};
</script>
<style lang="css" scoped>
@import url(@/assets/style/components/animatedText/animatedText.css);
</style>
